import styled from 'styled-components';

export const ContainerStatus = styled.div`
	label {
		font-family: Poppins-Medium, Heltica, Arial, sans-serif;
		font-size: 15px;
		color: #707070;
		display: inline-block;
	}

	select {
		display: block;
		padding: 8px 5px;
		border-radius: 12px;
		background-color: #FFFFFF;
		border: 1px solid #B7B7B7;
		font-size: 15px;
		color: #2B2932;
		outline: 0;
	}
`;

export const ContainerChecklists = styled.section`
	font-family: Poppins, Heltica, Arial, sans-serif;
	color: #707070;
	margin-top: 35px;

	.checklist {
		flex-wrap: wrap;
	}

	.tot-selecteds {
		display: inline-block;
		margin-left: 5px;
	}

	.container-checklist {
		min-width: 300px;
		margin: 20px 40px 0 0;

		&:last-child {
			margin-right: 0;
		}
	}

	.title-checklist {
		font-family: Poppins-Medium, Heltica, Arial, sans-serif;
		font-size: 15px;
		margin-bottom: 0;
	}

	.title-container {
		font-size: 15px;
	}

	.form-check {
		font-size: 14px;
		padding: 0;
		margin-bottom: 10px;

		input {
			margin-top: 5px;
		}

		[type="checkbox"]:not(:checked),
		[type="checkbox"]:checked {
			position: absolute;
			left: -9999px;
		}

		[type="checkbox"]:not(:checked) + label,
		[type="checkbox"]:checked + label {
			position: relative;
			padding-left: 1.95em;
			cursor: pointer;
		}

		[type="checkbox"]:not(:checked) + label:before {
			content: '';
			position: absolute;
			left: 0;
			top: 0;
			width: 1.25em; height: 1.25em;
			border: 1px solid #707070;
			background: #FFFFFF;
		}

		[type="checkbox"]:checked + label:before {
			content: '';
			position: absolute;
			left: 0;
			top: 0;
			width: 1.25em; height: 1.25em;
			border: 1px solid #707070;
			background: #707070;
		}
	}
`;

export const ButtonGear = styled.button`
	font-family: Poppins, Heltica, Arial, sans-serif;
	border-radius: 8px;
	background-color: #0FC821;
	color: #FFFFFF;
	font-size: 15px;
	text-transform: uppercase;
	padding: 10px 30px;
	border: 1px solid #0FC821;
	transition: all .3s ease-in-out;

	&:hover {
		background-color: transparent;
		color: #0FC821;
		border: 1px solid #0FC821;
	}

	&:focus {
		outline: 0;
	}
`;
